// extracted by mini-css-extract-plugin
export default {"thumb":"BriefThumbWipe_thumb__gQHOE","darkOnly":"BriefThumbWipe_darkOnly__I6sZm","lightOnly":"BriefThumbWipe_lightOnly__w6r0j"};